export const seniorSystemEngineerResume = `
【職務概要】
システムエンジニアとして15年間、金融システムを中心としたエンタープライズシステムの設計・開発・導入に携わってきました。特に市場系業務や決済システムの構築においては、アーキテクチャ設計からプロジェクト管理まで一貫して担当し、大規模システムの安定稼働に貢献してきました。近年はクラウド移行プロジェクトにおけるリーダーとして、オンプレミス環境からAWS・Azureへの移行戦略の策定や実装を主導。DevOpsの導入により開発期間の30%短縮、運用コスト削減にも成功しました。

また、マイクロサービスアーキテクチャやコンテナ技術を活用したシステム再構築にも精通しており、レガシーシステムのモダナイゼーションを複数プロジェクトで実現してきました。特に金融領域ではセキュリティとコンプライアンス要件を満たしながらも柔軟なシステム構築を追求し、ビジネス要件と技術的制約の最適なバランスを見出すことに注力しています。DXの進展に伴い、従来のシステム開発手法からアジャイル開発へのシフトを組織内で推進し、後進育成にも積極的に取り組んでいます。

【職務経歴】
・株式会社Algomaticフィナンシャルテクノロジー（2018年4月〜現在）
  ○ 会社概要：金融機関向けシステム開発を専門とする企業。従業員約300名。
  ○ 職務内容：
    - エンタープライズアーキテクト／プロジェクトマネージャー
    - 大手銀行グループの市場系業務統合システムのクラウド移行プロジェクト責任者
    - 為替・債券・デリバティブ取引の基幹システム設計・開発
    - チーム規模20名のプロジェクトマネジメント
  ○ 具体的な成果：
    - マイクロサービスアーキテクチャの導入により、システム拡張性を向上させ、新規金融商品追加時の開発期間を従来の半分に短縮
    - DevOpsパイプラインの構築により、リリースサイクルを月次から週次に改善
    - CI/CD環境の整備によりテスト工数を40%削減
    - バーゼル規制対応モジュールの開発により、コンプライアンス遵守を自動化
  ○ 使用した技術・ツール：
    - Java、Spring Boot、Oracle、AWS、Azure、Docker、Kubernetes、Jenkins、Git
    - Terraform、Ansible、Prometheus、Grafana
    - マイクロサービス設計、API設計、ドメイン駆動設計
  ○ 身につけたスキル：
    - エンタープライズアーキテクチャ設計、クラウドネイティブ開発
    - 市場系金融業務知識、金融規制対応知識
    - 大規模プロジェクト管理、リスク管理

・株式会社Algomaticシステムズ（2013年5月〜2018年3月）
  ○ 会社概要：SIer企業。様々な業種向けのシステム開発を手がける。従業員約800名。
  ○ 職務内容：
    - シニアシステムエンジニア／テクニカルリード
    - 大手流通グループの基幹システム再構築プロジェクト
    - 決済システムとポイント管理システムの開発・統合
    - アジャイル開発チームのテクニカルリード（8名）
  ○ 具体的な成果：
    - レガシーシステムのマイクロサービス化により、処理速度を3倍に向上
    - 複数店舗のリアルタイムデータ連携基盤の構築により、在庫管理精度を95%に改善
    - 障害発生率を75%削減し、システム安定稼働率99.99%を達成
    - アジャイル開発手法の導入により、開発期間を従来比25%短縮
  ○ 使用した技術・ツール：
    - Java、Spring Framework、PostgreSQL、Redis、RabbitMQ
    - REST API設計、マイクロサービスアーキテクチャ
    - Docker、GitLab CI/CD、Jira、Confluence
  ○ 身につけたスキル：
    - 分散システム設計、高可用性アーキテクチャ
    - アジャイル開発手法（スクラム）
    - テクニカルリーダーシップ、チームマネジメント

・株式会社Algomaticテクノロジーズ（2009年4月〜2013年4月）
  ○ 会社概要：ソフトウェア開発企業。Webアプリケーション開発を中心に事業展開。従業員約120名。
  ○ 職務内容：
    - システムエンジニア
    - Web系システム開発、ECサイト構築
    - 顧客管理・在庫管理システムの設計・開発
  ○ 具体的な成果：
    - 新規ECプラットフォームの構築により、クライアントの売上30%増加に貢献
    - 高負荷対応のためのシステム改修により、ピーク時の処理能力を5倍に向上
    - データベース最適化によるレスポンス時間50%改善
  ○ 使用した技術・ツール：
    - Java、PHP、MySQL、JavaScript、HTML/CSS
    - Linux、Apache、Tomcat、SVN
  ○ 身につけたスキル：
    - Webアプリケーション設計・開発
    - データベース設計・チューニング
    - 性能改善・負荷対策

【受賞・表彰歴】
・2022年 株式会社Algomaticフィナンシャルテクノロジー 技術貢献賞
  マイクロサービスアーキテクチャ導入による開発生産性向上の取り組みが評価
・2021年 日本クラウドコンピューティング協会 ベストプラクティス賞
  金融システムのクラウド移行プロジェクトにおける独自のセキュリティフレームワーク開発が評価
・2017年 株式会社Algomaticシステムズ 最優秀プロジェクト賞
  流通基幹システム再構築プロジェクトでの技術的貢献が評価
・2015年 IT業界誌主催 「年間プロジェクトリーダー賞」
  アジャイル開発手法の国内導入事例としての評価

【資格】
・情報処理安全確保支援士（2022年4月）
・AWS認定ソリューションアーキテクト - プロフェッショナル（2021年5月）
・Azure認定ソリューションアーキテクト エキスパート（2020年9月）
・PMP（Project Management Professional）（2018年2月）
・情報処理技術者試験 システムアーキテクト（2016年10月）
・ITIL Foundation v4（2015年7月）
・Oracle認定Javaプログラマ（Gold）（2012年3月）
・情報処理技術者試験 データベーススペシャリスト（2011年4月）
・情報処理技術者試験 応用情報技術者（2010年10月）

【マネジメント経験】
・2020年〜現在：クラウド移行チームのプロジェクトマネージャーとして20名規模のチームをマネジメント
  ○ チーム構成：SE 12名、インフラエンジニア5名、テスターQA 3名
  ○ 成果：
    - マルチクラウド環境における開発標準化プロセスの確立
    - メンバーのクラウド技術力向上のための社内研修プログラム立案・実施
    - チーム全体のエンジニアリング生産性を前年比35%向上
    - 若手エンジニア5名の育成・昇格に貢献
・2016年〜2018年：アジャイル開発チームのテクニカルリードとして8名のチームをマネジメント
  ○ スクラムマスターとして、スプリント計画・レビュー・振り返りを主導
  ○ 技術的な意思決定とアーキテクチャ設計の主導
  ○ コードレビュープロセスの確立とメンターシップ制度の導入

【語学力】
・英語：ビジネスレベル
  ○ TOEIC 850点（2021年）
  ○ 海外ベンダーとの技術ミーティング、契約交渉、技術文書作成
  ○ グローバルチームとの英語での定例会議進行、技術プレゼンテーション
` as const;
